import { ReactElement } from 'react'
import { useMatchMedia } from '../../hooks/useMatchMedia'
import { pageBreakpoints } from '../../config/pageBreakpoints'
import { MobileFooter } from './MobileFooter'
import { WebFooter } from './WebFooter'

export const Footer = (): ReactElement => {
  const isMobile = useMatchMedia(`(max-width: ${pageBreakpoints.md})`)

  return isMobile ? <MobileFooter /> : <WebFooter />
}
